





































































































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop, Watch } from 'vue-property-decorator'
import {
  BankAccountResourceModel,
  BankAccountType,
  BankAccountWithdrawPeriod,
  BankNames
} from '@/modules/bank-account/models/bank-account-resource.model'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Radio from '@/modules/shared/components/shared/kit/Radio.vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import BankAccountNameSelectInput from '@/modules/bank-account/components/shared/BankAccountNameSelectInput.vue'
import collect from 'collect.js'
import { ToggleButton } from 'vue-js-toggle-button'
import MediaUploader from '@/modules/media/components/shared/MediaUploader.vue'
import { fileFilter } from '@/modules/shared/helpers/file.helper'
import clone from 'just-clone'
import { MediaResourceModel } from '@/modules/media/models/media-resource.model'

@Component({
  components: {
    MediaUploader,
    BankAccountNameSelectInput,
    BaseInput,
    BaseSelect,
    Radio,
    ToggleButton
  }
})
export default class BankAccountBaseForm extends Vue {
  constructor() {
    super()
  }

  @Prop() value: BankAccountResourceModel
  @Prop({ required: true }) bankNames: { [key in BankNames]: string }
  @Prop({ required: false }) withdrawPeriods: { [key in BankAccountWithdrawPeriod]: string }
  @Prop({ default: true }) hasWithdraw: boolean
  @Prop({ default: false }) hasUploader: boolean
  @Prop({ default: false }) submit: boolean
  bankAccountModel: BankAccountResourceModel = this.initData()
  BankAccountType = BankAccountType
  persianWeekdays = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه']
  //
  isImageDeletable: boolean = false
  newImage: Array<File> = []
  showReplaceImage: boolean = false

  mounted() {
    this.isImageDeletable = !(this.bankAccountModel?.national_identity_image.some((image) => 'url' in image))
  }

  @Watch('submit')
  onSubmit(newVal) {
    if (newVal) {
      this.bankAccountModel = this.initData()
      this.isImageDeletable = !(this.bankAccountModel?.national_identity_image.some((image) => 'url' in image))
    }
  }

  @Watch('bankAccountModel', { immediate: true, deep: true })
  onModelChange() {
    let cloned: BankAccountResourceModel = clone(this.bankAccountModel)
    cloned.national_identity_image = fileFilter<File | MediaResourceModel>(cloned.national_identity_image)
    this.$emit('input', cloned)
  }

  @Watch('newImage')
  onImageChange() {
    let cloned: BankAccountResourceModel = clone(this.bankAccountModel)
    cloned.national_identity_image = fileFilter<File | MediaResourceModel>(cloned.national_identity_image)
    if (this.newImage.length > 0) cloned.national_identity_image = this.newImage
    this.$emit('input', cloned)
  }

  get _accountType() {
    return this.bankAccountModel.account_type === BankAccountType.NATURAL_PERSON
  }

  set _accountType(val) {
    this.bankAccountModel.account_type = (val) ? BankAccountType.NATURAL_PERSON : BankAccountType.LEGAL_PERSON
  }

  get periodOptions() {
    return collect(this.withdrawPeriods).map((item, index) => ({
      label: item,
      value: index
    })).toArray()
  }

  get showWithdraw() {
    return this.hasWithdraw && this.withdrawPeriods
  }

  get showUploader() {
    return this.hasUploader && this.bankAccountModel.account_type === BankAccountType.LEGAL_PERSON
  }

  get showWithdrawDay() {
    return [
      BankAccountWithdrawPeriod.WEEKLY,
      BankAccountWithdrawPeriod.MONTHLY
    ].includes(this.bankAccountModel.withdraw_period) && this.hasWithdraw
  }

  get withdrawDayOptions() {
    return (this.bankAccountModel.withdraw_period === BankAccountWithdrawPeriod.WEEKLY)
      ? this.withdrawWeeklyOptions
      : this.withdrawMonthlyOptions
  }

  get withdrawWeeklyOptions() {
    return collect(this.persianWeekdays).map((item, index) => ({
      label: item,
      value: index
    })).toArray()
  }

  get withdrawMonthlyOptions() {
    let days: { label: string, value: number }[] = []
    for (let i = 1; i <= 29; i++) {
      days.push({
        label: 'روز ' + i,
        value: i
      })
    }
    return days
  }

  protected setProperty(key, value) {
    this.$set(this.bankAccountModel, key, value)
  }

  initData(): BankAccountResourceModel {
    return {
      id: this.value?.id || null,
      account_type: this.value?.account_type || BankAccountType.NATURAL_PERSON,
      sheba: this.value?.sheba || null,
      card_number: this.value?.card_number || null,
      account_owner_name: this.value?.account_owner_name || '',
      bank_name: this.value?.bank_name || null,
      withdraw_period: this.value?.withdraw_period || BankAccountWithdrawPeriod.OFF,
      withdraw_period_day: this.value?.withdraw_period_day || null,
      national_identity_image: this.value?.national_identity_image || []
    }
  }

}
